import { Handshake, Award, Shield } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

export const IndustryPartnersPage = () => {
  // Partner logos - mix of actual and placeholders
  const partners = [
    { 
      name: "Acuity Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/3tb9vqap_acuity-logo.png"
    },
    { 
      name: "Safeco Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/xg6hs4g0_Safeco%20logo.jpg"
    },
    { 
      name: "Travelers Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/ux1elrb5_Travelers-Logo.jpg"
    },
    { 
      name: "West Bend Mutual Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/f9ayh4v7_West%20Bend%20Logo.png"
    },
    { 
      name: "Integrity Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/kd5y09jq_Integrity%20logo.png"
    },
    { 
      name: "Chubb Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/ze1yqjv7_Chubb-logo.jpg"
    },
    { 
      name: "Progressive Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/00tcohgz_Progressive-logo-500x281.png"
    },
    { 
      name: "Foremost Insurance Group", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/mljq5i7n_foremost-insurance-logo-1024x229.jpg"
    },
    { 
      name: "Liberty Mutual Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/a9tdlyc9_LibertyMutualInsurance%20logo.png"
    },
    { 
      name: "GEICO Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/tt2sjaib_GEICO-logo.avif"
    },
    { 
      name: "Hagerty Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/hovz18rw_Hagerty-Insurance-Logo-300x100.png"
    },
    { 
      name: "Universal Property & Casualty Insurance", 
      placeholder: false,
      logo: "https://customer-assets.emergentagent.com/job_midwest-coverage/artifacts/ufijgbh0_Universal-Property.jpg"
    },
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary to-blue-700 text-white section-padding overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1742659655744-3504f1152644?w=1600&q=80')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-blue-700/90"></div>
        </div>
        <div className="container-custom relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <Handshake className="h-20 w-20 mx-auto mb-6 text-blue-100" />
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Industry Partners</h1>
            <p className="text-xl text-blue-100">
              Working with leading insurance carriers to bring you the best coverage options
            </p>
          </div>
        </div>
      </section>

      {/* Partner Benefits */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              The Independent Advantage
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              As an independent insurance agency, we partner with multiple top-rated carriers. This means we work for you, 
              not the insurance companies, ensuring you get the best coverage at competitive rates.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <Card className="border-2 border-primary/20">
              <CardContent className="pt-6 text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-foreground">Multiple Options</h3>
                <p className="text-muted-foreground">
                  Access to numerous insurance carriers means more choices and better coverage tailored to your needs
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 border-primary/20">
              <CardContent className="pt-6 text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-foreground">Competitive Rates</h3>
                <p className="text-muted-foreground">
                  We shop the market on your behalf to find the most competitive pricing without sacrificing coverage
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 border-primary/20">
              <CardContent className="pt-6 text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Handshake className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-foreground">Trusted Relationships</h3>
                <p className="text-muted-foreground">
                  Long-standing partnerships with A-rated carriers ensure reliable claims service and financial stability
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="section-padding bg-white border-t border-gray-200">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Our Carrier Partners
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              We work with leading insurance carriers to bring you the best coverage options
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {partners.map((partner, index) => (
              <Card key={index} className="card-hover border-2 hover:border-primary/50 bg-white">
                <CardContent className="p-8 flex items-center justify-center min-h-[150px]">
                  {partner.placeholder ? (
                    <div className="text-center">
                      <Shield className="h-16 w-16 text-primary/30 mx-auto mb-2" />
                      <p className="text-sm text-muted-foreground font-medium">{partner.name}</p>
                    </div>
                  ) : (
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className={`max-w-full h-auto object-contain ${
                        partner.name === "West Bend Mutual Insurance" 
                          ? "max-h-[300px]"
                          : partner.name === "Chubb Insurance"
                          ? "max-h-[150px]"
                          : partner.name === "Universal Property & Casualty Insurance"
                          ? "max-h-[400px]"
                          : "max-h-[100px]"
                      }`}
                    />
                  )}
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground">
              * Additional partner logos can be added. We work with multiple A-rated carriers to provide you the best coverage options.
            </p>
          </div>
        </div>
      </section>

      {/* Partner Criteria */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-foreground">
              How We Select Our Partners
            </h2>
            <p className="text-lg text-muted-foreground text-center mb-12">
              We carefully evaluate and partner with insurance carriers based on strict criteria to ensure 
              you receive the highest quality coverage and service
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card className="border-l-4 border-l-primary">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-semibold mb-2 text-foreground">Financial Strength</h3>
                  <p className="text-muted-foreground">
                    All partners maintain strong financial ratings to ensure they can fulfill claims obligations
                  </p>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-primary">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-semibold mb-2 text-foreground">Claims Service</h3>
                  <p className="text-muted-foreground">
                    Proven track record of fair, efficient claims handling and customer satisfaction
                  </p>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-primary">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-semibold mb-2 text-foreground">Product Quality</h3>
                  <p className="text-muted-foreground">
                    Comprehensive coverage options with flexible policy features and competitive pricing
                  </p>
                </CardContent>
              </Card>

              <Card className="border-l-4 border-l-primary">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-semibold mb-2 text-foreground">Market Reputation</h3>
                  <p className="text-muted-foreground">
                    Established reputation for integrity, reliability, and exceptional customer service
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
